import AsnDetailStore from "../../../stores/AsnDetailStore";
import AsnStore from "../../../stores/AsnStore";
import DomainStore from "../../../stores/CmrDomainStore";
import ServiceStore from "../../../stores/CmrServiceStore";
import {setElementsFromScope, swapClasses, insertValAndManageFocus, show, hide} from "../../../utilities/selectorHelpers";
import {unbindAll, extractElements} from "../../../utilities/viewHelpers";
import _ from "underscore";
import $ from "jquery";
import ReviewDetailRowView from "./ReviewDetailRowView";
import render from "../../../utilities/render";
import {isBlank,isPresent} from "../../../utilities/general";
const subTotalRowHtml = require("./html/reviewSubTotalRow.html");

const elementsMap = {
  reviewTabServiceInner: ".review-tab-service-inner"
};

export default function ReviewServicesView(el, {
  calcSubTotal,
  readOnly}={}){
  const self = this;
  const els = {};
  let reviewDetailRowViews = [];

  self.init = function(){
    setElements();
    attachWidgets();
    bindElements();
    bindStores();
    renderChildren();
  };

  function setElements(){
    setElementsFromScope(els, elementsMap, el);
  }

  function attachWidgets(){
  }

  function bindElements(){
  }

  function onAddServiceChanged(){
  }

  function renderChildren(){
    unbindAll(reviewDetailRowViews);
    el.html('');
    renderServices();
    renderProducts();
    el.append(renderSubTotalRow());
  }

  function renderSubTotalRow(){
    return render(
      subTotalRowHtml,
      {
        subtotal: calcSubTotal()
      }
    )
  }

  function renderServices(){
    if(getServices().length){
      const reviewDetailRowView = new ReviewDetailRowView(getServices(), null, {});
      reviewDetailRowView.init();
      el.append(extractElements([reviewDetailRowView]));
    }
  }

  function renderProducts(){
    _(groupBySku()).chain().map((asnDetails, sku)=>{
      if(getDeduppedServices(asnDetails).length){
        const asnDetail = asnDetails[0];
        const reviewDetailRowView = new ReviewDetailRowView(getDeduppedServices(asnDetails),asnDetail, {
          asnDetails
        });
        reviewDetailRowView.init();
        el.append(extractElements([reviewDetailRowView]));
      }
    });
  }

  function getDeduppedServices(asnDetails){
    const asnDetailIds = getAsnDetailIds(asnDetails);
    return ServiceStore.getServicesViaAsnDetailIds([asnDetailIds[0]]);
  }

  function getAsnDetailIds(asnDetails){
    return _(asnDetails).pluck("id");
  }

  function getServices(){
    return ServiceStore.getServicesViaAsnId(getAsnId());
  }

  function bindStores(){
    AsnStore.bindListener("asns:shipping_method_changed", renderChildren);
    ServiceStore.bindListener("cmr_services:add", renderChildren);
    ServiceStore.bindListener("cmr_services:remove", renderChildren);
    ServiceStore.bindListener("cmr_services:change", renderChildren);
    AsnDetailStore.bindListener("asn_details:add", renderChildren);
    AsnDetailStore.bindListener("asn_details:remove", renderChildren);
    AsnDetailStore.bindListener("asn_details:change", renderChildren);
  }

  self.unbindListeners = function(){
    AsnStore.unbindListener("asns:shipping_method_changed", renderChildren);
    ServiceStore.unbindListener("cmr_services:add", renderChildren);
    ServiceStore.unbindListener("cmr_services:remove", renderChildren);
    ServiceStore.unbindListener("cmr_services:change", renderChildren);
    AsnDetailStore.unbindListener("asn_details:add", renderChildren);
    AsnDetailStore.unbindListener("asn_details:remove", renderChildren);
    AsnDetailStore.unbindListener("asn_details:change", renderChildren);
  }

  function getAsnId(){
    return getAsn().id;
  }

  function groupBySku(){
    return AsnDetailStore.groupBySku(getAsnDetails());
  }

  function getAsn(){
    return AsnStore.getAsnWithShippingMethod();
  }

  function getAsnDetails(){
    return AsnStore.getAsnDetails(getAsn());
  }
}



// WEBPACK FOOTER //
// ./src/pages/asns/ServicesTab/ReviewServicesView.js